import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connectRefinementList } from 'react-instantsearch-dom'
import MenuItem from '@material-ui/core/MenuItem'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import ClearIcon from '@material-ui/icons/Clear'
import { PillSelect } from './Refiners.styles'

const CustomRefinementList = (props) => {
  const {
    currentRefinement,
    items,
    refine,
  } = props
  const itemsList = items.flatMap(e => e.label)
  const [isSelectedAll, setIsSelectedAll] = useState(false)

  useEffect(() => {
    refine(isSelectedAll ? itemsList : [])
  }, [isSelectedAll])


  // get URL params here and set the category defaulted to those values coming through
  // see local README for more info at ./README.md
  useEffect(() => {
    const url = new URLSearchParams(window.location.search)
    const tags = url.get('refinementList[tags]')
    if (tags) {
      refine(tags)
    }

    if (currentRefinement && currentRefinement.length > 0) {
      refine(currentRefinement)
    }
  }, [])

  const customRefinementLabels = currentRefinement.map(item => (item === 'PGA Family Cup' ? 'PGA Family Golf' : item))
  return (
    <PillSelect
      variant="outlined"
      value={currentRefinement || ''}
      displayEmpty
      multiple
      IconComponent={KeyboardArrowDownIcon}
      renderValue={() => customRefinementLabels.join(', ') || 'Category'}
    >
      <MenuItem>
        <FormControlLabel
          control={<Checkbox checked={itemsList.length === currentRefinement.length} color="primary" />}
          label="Show All"
          labelPlacement="end"
          onChange={() => setIsSelectedAll(!isSelectedAll)}
        />
      </MenuItem>
      {items.map(item => (
        <MenuItem key={item.label}>
          <FormControlLabel
            value={item.value}
            onChange={() => {
              refine(item.value)
            }}
            control={<Checkbox checked={(currentRefinement.indexOf(item.label) > -1 || item.isRefined)} color="primary" />}
            label={`${item.label === 'PGA Family Cup' ? 'PGA Family Golf' : item.label} (${item.count})`}
            labelPlacement="end"
          />
        </MenuItem>
      ))}
      {currentRefinement.length
        && (
          <MenuItem>
            <FormControlLabel
              control={<Checkbox icon=<ClearIcon /> color="primary" />}
              label="Clear All"
              labelPlacement="end"
              onChange={() => {
                setIsSelectedAll(false)
                refine([])
              }}
            />
          </MenuItem>
        )
      }
    </PillSelect>
  )
}

CustomRefinementList.propTypes = {
  currentRefinement: PropTypes.array,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    isRefined: PropTypes.bool,
    count: PropTypes.number,
  })),
  refine: PropTypes.func,
}

export default connectRefinementList(CustomRefinementList)
